/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { ContractLocation, ContractLocationsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ContractLocationsState, RootState> = {
  productLocations(state): Array<ContractLocation> {
    return state.contractLocations;
  },
};
